import * as React from "react";

// MUI
import {
	withStyles,
	WithStyles,
	createStyles,
	Theme,
} from "@material-ui/core/styles";
import {
	Tooltip,
	Select,
	SelectProps,
	FormControl,
	InputLabel,
	Typography,
} from "@material-ui/core";
import Utility from "../../domain/classes/Utility";

// NPM
import { animated } from "react-spring/renderprops-universal";

// Interfaces
import ISelectable from "../../domain/interfaces/ISelectable";

export const styles = (theme: Theme) =>
	createStyles({
		root: {},
	});

export interface PromptedSelectProps extends SelectProps {
	title: string;
	selectLabel: string;
	options: ISelectable[];
	errorText?: string;
}

const PromptedSelect = React.forwardRef<
	HTMLInputElement,
	PromptedSelectProps & WithStyles<typeof styles>
>(
	(
		{
			title,
			classes,
			className,
			value,
			onChange,
			selectLabel,
			errorText,
			options,
			...selectProps
		},
		ref
	) => {
		const selectId: string = Utility.generateSelectId(selectLabel);

		return (
			<Tooltip title={title} placement="top" arrow>
				<FormControl variant="outlined" size="small" fullWidth>
					<InputLabel htmlFor={selectId}>{selectLabel}</InputLabel>
					<Select
						{...selectProps}
						native
						value={value}
						onChange={onChange}
						label={selectLabel}
						inputProps={{ name: selectLabel, id: selectId }}
					>
						{options.map((opt: ISelectable) => (
							<option value={opt.value} key={opt.key}>
								{opt.displayText}
							</option>
						))}
					</Select>
					{errorText && (
						<Typography variant="caption" color="error">
							{errorText}
						</Typography>
					)}
				</FormControl>
			</Tooltip>
		);
	}
);

const StyledPromptedSelect = withStyles(styles, {
	classNamePrefix: Utility.generateClassName("PromptedSelect"),
})(PromptedSelect);

export default StyledPromptedSelect;

export const AnimatedPromptedSelect = animated(StyledPromptedSelect);
